import React from 'react';

import { MenuSeparator } from '../menu/MenuSeparator.view';
import MenuToggler from '../menu-toggler';
import Ellipsis from '../common/Ellipsis';

import { MenuLinkAction } from '../menu/MenuLinkAction.view';

// @ts-ignore
import MenuIcon from '../../images/icons/menu.svg';

import type { Subscription } from '../../types/subscription.types';

import { TestID } from '../../testID';

import './SubscriptionsSelector.css';

export const SubscriptionsSelector: React.FC<{
  currentSubId: string;
  currentSubName: string;
  subscriptions: Subscription[];
}> = ({ currentSubId, currentSubName, subscriptions }) => (
  <div className="subscriptions-selector">
    <div className="subscriptions-selector__current-sub">
      <Ellipsis data-testid={TestID.SubscriptionsSelectorCurrentName}>{currentSubName}</Ellipsis>
    </div>
    <MenuToggler
      label={<MenuIcon className="subscriptions-selector__icon" />}
      labelClassName="subscriptions-selector__toggler"
      isDashboardIcon={true}
      buttonTestId={TestID.SubscriptionsSelectorToggleButton}
      userMenuTestId={TestID.SubscriptionsSelectorToggleMenu}
    >
      <MenuLinkAction
        label="Dashboard"
        title="Dashboard"
        to="/dashboard"
        role="menuitem"
        data-testid={TestID.SubscriptionsSelectorDashboardLink}
      />
      <MenuSeparator />
      {subscriptions.map((subscription) => {
        const isCurrentSub = subscription.id === currentSubId;

        return (
          <MenuLinkAction
            key={subscription.id}
            label={subscription.name}
            title={
              isCurrentSub
                ? `Current selected subscription: ${subscription.name}`
                : subscription.name
            }
            to={`/switch-to-subscription/${subscription.id}`}
            role="menuitem"
            linkClassName={isCurrentSub ? 'menu-item-link-selected' : ''}
            aria-current={isCurrentSub ? 'page' : undefined}
            tabIndex={isCurrentSub ? -1 : undefined}
            data-testid={TestID.SubscriptionsSelectorLink}
          />
        );
      })}
      <MenuSeparator />
      <MenuLinkAction
        label="New subscription"
        title="New subscription"
        to="/create-subscription"
        role="menuitem"
        data-testid={TestID.SubscriptionsSelectorNewSubscriptionLink}
      />
    </MenuToggler>
  </div>
);
